import { auth } from "../plugins/firebase";
import firebase from "firebase/compat/app";

export default class Auth {
    public static getCurrentFirebaseUser(): firebase.User | null {
        return auth.currentUser;
    }
}